import Root from './Root';
import Tab from './Tab';

export default {
  Root,
  Tab
};
